import { useQuery } from "react-query";
import { API_KEY_GET_PROGRAM_TYPES } from "../utils";
import { getProgramTypes } from "../api";

export const useGetProgramTypes = () => {
  return useQuery([API_KEY_GET_PROGRAM_TYPES], () => getProgramTypes());
};
